import React from 'react';

import { Link, Typography, CardContent, Card } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import PartnerAudienceDetails from 'scenes/CustomAudiences/PartnerAudiences/components/PartnerAudienceDetails';

export default ({ data }) => {
  const [childComponent, openChildComponent] = useChildComponent();

  const handleOpenPartnerAudience = async (_e, { id }) => {
    openChildComponent(PartnerAudienceDetails, {
      id: id,
    });
  };

  return (
    <React.Fragment>
      {data?.map((row) => (
        <Card elevation={6} fullHeight={true}>
          <CardContent>
            <Typography>
              <Link
                onClick={(e) =>
                  handleOpenPartnerAudience(e, {
                    id: row.id,
                  })
                }
              >
                {row.name}
              </Link>
            </Typography>
          </CardContent>
        </Card>
      ))}
      {childComponent}
    </React.Fragment>
  );
};
